import React from "react";
import MainContent from "layout/MainContent";

export default function Dashboard() {
  return (
    <>
      <MainContent />
    </>
  );
}
